import { ISpellingExemption, ISpellingExemptionGetResponse } from "@edgetier/watchtower-types";

/**
 * Update the react query cache without the spelling exemption passed.
 * @param spellingExemption
 * @param cachedSpellingExemptions The spelling exemptions in the cache.
 * @returns An updated object without the exemption's information.
 */
export const removeSpellingExemptionFromCache = (spellingExemption: ISpellingExemption) => (
    cachedSpellingExemptions: ISpellingExemptionGetResponse | undefined
) => {
    const pagination = cachedSpellingExemptions?.pagination ?? { nextPage: null, previousPage: null };
    const newSpellingExemptions = (cachedSpellingExemptions?.items ?? []).filter(
        (queryExemption) => spellingExemption.spellingExemptionId !== queryExemption.spellingExemptionId
    );
    return {
        pagination,
        items: newSpellingExemptions,
    };
};
